<template>
    <div class="notice_details_box">
        <div class="top_box">
            <div class="title_box w_box">
                <div class="left">公告详情</div>
                <div class="btn" @click="closeChange"><close-outlined />关闭</div>
            </div>
        </div>

        <div class="w_box content_box">
            <div class="title_box">
                <div class="title">{{noticeItem.title}}</div>
                <div class="time">{{dayjs(noticeItem.createTime).format("YYYY-MM-DD HH:mm:ss")}}</div>
            </div>
            <div class="value_box" v-html="noticeItem.content"></div>
        </div>

    </div>
</template>

<script setup> 
import { ref } from "vue"; 
import { CloseOutlined } from '@ant-design/icons-vue';
import dayjs from "dayjs";
const noticeItem = ref({});
noticeItem.value = JSON.parse(localStorage.getItem("noticeItemData"));  

function closeChange() {
    window.close();
}

</script>

<style lang="scss" scoped> 
@import "@/style/var.scss";
.w_box { 
    margin: 0 auto; 
    width: 1100px; 
} 

.notice_details_box { 
    width: 100%; 
    height: 100%;
    background: #F0F2F5;
    overflow: hidden;
    position: relative;
} 
.top_box { 
    // position: sticky; 
    position: fixed; 
    top: 0; 
    left: 0; 
    width: 100%; 
    height: 50px; 
    background: #FFFFFF; 
    display: flex;
    align-items: center;
    .title_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999EA9;
        .left {
            position: relative;
            padding-left: 10px;
            font-size: 18px;
            font-weight: 700;
            display: flex;
            align-items: center;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                width: 4px;
                height: 20px;
                background: $primary-color;
            }
        }
        .btn {
            width: 70px;
            height: 30px;
            border: 1px solid #E4E4E4;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover {
                background: rgba(153, 158, 169, 0.2);
            }
        }
    }
} 
.content_box { 
    // margin: 30px auto; 
    margin: 80px auto 30px;
    padding: 30px;
    min-height: calc(100vh - 60px - 50px);
    background: #FFFFFF;

    // height: 100vh;
    .title_box {
        padding: 10px 0 30px;
        text-align: center;
        border-bottom: 1px solid #E9E9E9;
        .title {
            font-weight: 600; 
            color: #666666; 
            font-size: 20px; 
        }
        .time {
            margin-top: 10px;
            font-size: 14px; 
            color: #999999; 
        }
    }
    .value_box {
        padding: 20px;
    }
} 

</style> 
